import classNames from 'classnames'
import {useAlphabet} from './AlphabetContext'
import {useSearch} from './SearchContext'

export default function Alphabet({ alphabet, makeSearchApiCall }) {
  const {currentLetter, setCurrentLetter} = useAlphabet()
  const {setSearchText, setDomain} = useSearch()

  const letterClicked = (event, letter) => {
    event.preventDefault()
    setCurrentLetter(letter)
    setSearchText('')
    setDomain('')
    makeSearchApiCall({
      starts_with: letter,
    })
  }

  return (
    <div className="alphabet">
      <a href="#" className={classNames('alphabet-letter', {
        'alphabet-letter--empty': alphabet.active.length === 0,
        'alphabet-letter--current' : currentLetter === '',
      })} onClick={(event) => letterClicked(event, '')}>
        {Drupal.t('All')}
      </a>

      {alphabet.letters.map((letter, index) => (
        <a href="#" className={classNames('alphabet-letter', {
          'alphabet-letter--empty': !alphabet.active.includes(letter),
          'alphabet-letter--current' : currentLetter === letter,
        })} key={index} onClick={(event) => letterClicked(event, letter)}>
          {letter}
        </a>
      ))}
    </div>
  )
}
